import React, { useContext, useEffect } from 'react';
import NavbarTop from '../components/navbar/NavbarTop';
import NavbarVertical from '../components/navbar/NavbarVertical';
import Footer from '../components/footer/Footer';
import Breadcrumbs from '../components/common/Breadcrumbs';
import AppContext from '../context/Context';
import RootRoutes from '../routes/RootRoutes';
import { SocketContext, NotificationContext } from '../context/Context';
import { useSelector } from 'react-redux';
import moment from 'moment';

const RootLayout = () => {
    const { isFluid, isTopNav } = useContext(AppContext);
    const socket = useContext(SocketContext);
    const { user } = useSelector(state => state.auth);
    const { setNotifications } = useContext(NotificationContext);

    useEffect(() => {
        if (socket) {
            user?.role === 'root' && socket.private(`notification-ticket`).listen('TicketEvent', (({ response }) => {
                setNotifications(prev => [{
                    created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                    data: JSON.stringify(response),
                    type: 'new-ticket',
                    read_at: null
                }, ...prev])
            }));
        }
        return () => {
            if (socket) {
                socket.leave(`notification-ticket`);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket])

    return <div className={isFluid ? 'container-fluid' : 'container'}>
        {!isTopNav && <NavbarVertical />}
        <div className="content">
            <NavbarTop />
            <Breadcrumbs />
            <RootRoutes />
            <Footer />
        </div>
    </div>
}

export default RootLayout;